export const isDateExpired = (expiryDate: Date) => {
  const currentDate = new Date(Date.now());

  const expiryDateOnly = new Date(expiryDate);
  const currentDateOnly = new Date(currentDate);

  expiryDateOnly.setHours(0, 0, 0, 0);
  currentDateOnly.setHours(0, 0, 0, 0);

  return expiryDateOnly < currentDateOnly;
};

export const isDateExpiring = (expiryDate: Date) => {
  const now = new Date();
  const oneMonthInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
  const oneMonthLater = new Date(now.getTime() + oneMonthInMilliseconds);
  return expiryDate <= oneMonthLater && expiryDate >= now;
};
